import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Alert, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { getMeta } from "./api";
import DueOverview from "./DueOverview";
import Sessions from "./Sessions";
import Qualifications from "./Qualifications";
import Assessments from "./Assessments";
import Topics from "./Topics";
import "./safety.css";

// Where the maintenance module lists the Betriebsmittelprüfungen (DGUV Vorschrift 3)
const EQUIPMENT_INSPECTIONS_PATH = "/user/maintenance";

const TABS = ["due", "sessions", "qualifications", "assessments", "topics"];

/** Arbeitsschutz: due list, Unterweisungen, qualifications, risk assessments, topics. */
const Safety = () => {
  const { t } = useTranslation("dashboard");
  const history = useHistory();
  const location = useLocation();
  const [meta, setMeta] = useState(null);
  const tabFromUrl = new URLSearchParams(location.search).get("tab");
  const tab = TABS.includes(tabFromUrl) ? tabFromUrl : "due";

  const loadMeta = useCallback(() => {
    getMeta()
      .then(res => setMeta(res.data))
      .catch(generalErrorAlert);
  }, []);

  useEffect(loadMeta, [loadMeta]);

  const setTab = key => history.replace({ search: key === "due" ? "" : `?tab=${key}` });

  return (
    <div className="safety-page">
      <Tabs
        activeKey={tab}
        onChange={setTab}
        destroyInactiveTabPane
        items={[
          {
            key: "due",
            label: t("Due list"),
            children: <DueOverview onGoTo={setTab} />
          },
          { key: "sessions", label: t("Safety instructions"), children: <Sessions meta={meta} /> },
          {
            key: "qualifications",
            label: t("Qualifications & checks"),
            children: <Qualifications meta={meta} />
          },
          {
            key: "assessments",
            label: t("Risk assessments"),
            children: <Assessments meta={meta} />
          },
          {
            key: "topics",
            label: t("Topics"),
            children: <Topics meta={meta} onChanged={loadMeta} />
          }
        ]}
      />
      <Alert
        className="sf-footer-note"
        type="info"
        showIcon
        message={t("Equipment inspections (DGUV V3) are recorded in the maintenance module.")}
        action={<Link to={EQUIPMENT_INSPECTIONS_PATH}>{t("Open")}</Link>}
      />
    </div>
  );
};

export default Safety;
